// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// COMPONENTS
import DateInput from 'components/inputs/DateInput';
import TimeInput from 'components/inputs/TimeInput';
import TextAreaInput from 'components/inputs/TextAreaInput/index';
import TextInput from 'components/inputs/TextInput';
import ClientInput from 'components/inputs/ClientInput';
import SessionCategoryInput from 'components/inputs/SessionCategoryInput';
import Button from 'components/common/Button';
import FormItem from 'components/common/FormItem';
import Row from 'components/common/Row';
import Col from 'components/common/Col';

class SessionForm extends React.PureComponent {
  state = {
    session: {
      title: this.props.session && this.props.session.title,
      description: this.props.session && this.props.session.description,
      sessionDate: (this.props.session && this.props.session.sessionDate) || moment(),
      sessionTime: (this.props.session && this.props.session.sessionTime) || moment().format('h:mm a'),
      category: this.props.session && this.props.session.category,
      clientId: (this.props.session && this.props.session.clientId) || this.props.clientId,
    },
  };

  formatDate = date =>
    moment
      .utc(date)
      .startOf('day')
      .toISOString();

  onChange = newValue => {
    this.setState({
      session: {
        ...this.state.session,
        ...newValue,
      },
    });
  };

  onSubmit = () => {
    this.props.handleSubmit({
      ...this.state.session,
      sessionDate: this.formatDate(this.state.session.sessionDate),
    });
  };

  render() {
    return (
      <Row gutter={20}>
        <Col xs={24}>
          <FormItem label="Title">
            <TextInput onChange={title => this.onChange({ title })} value={this.state.session.title} />
          </FormItem>
        </Col>
        <Col xs={12}>
          <FormItem label="Session Date">
            <DateInput onChange={sessionDate => this.onChange({ sessionDate })} value={this.state.session.sessionDate} />
          </FormItem>
        </Col>
        <Col xs={12}>
          <FormItem label="Session Time">
            <TimeInput onChange={sessionTime => this.onChange({ sessionTime })} value={this.state.session.sessionTime} />
          </FormItem>
        </Col>
        <Col xs={24}>
          <FormItem label="Notes">
            <TextAreaInput
              onChange={e => this.onChange({ description: e.target.value })}
              value={this.state.session.description}
            />
          </FormItem>
        </Col>
        <Col xs={12}> 
          <FormItem label="Category">
            <SessionCategoryInput
              onChange={category => this.onChange({ category })}
              value={this.state.session.category}
              sessionTypes={this.props.sessionTypes}
            />
          </FormItem>
        </Col>
        <Col xs={12}> 
          <FormItem label="Client">
            <ClientInput onChange={clientId => this.onChange({ clientId })} value={this.state.session.clientId} />
          </FormItem>
        </Col>
        <FormItem>
          <Button fullWidth loading={this.props.loading} disabled={this.props.loading} onClick={this.onSubmit}>
            {!this.props.loading ? this.props.onOkText : 'Saving...'}
          </Button>
        </FormItem>
      </Row>
    );
  }
}

SessionForm.propTypes = {
  sessionTypes: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onOkText: PropTypes.string.isRequired,
};

SessionForm.defaultProps = {
  sessionTypes: [],
  loading: false,
  onOkText: 'Save Session',
};

export default SessionForm;



// WEBPACK FOOTER //
// ./src/components/forms/SessionForm/index.js